// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehicleDataOverrideAreaId } from './VehicleDataOverrideAreaId'
import {
  VehicleDataOverrideAreaNavigation,
  VehicleDataOverrideAreaNavigationIcon,
} from './VehicleDataOverrideAreaNavigation'
import { VehicleDataOverrideAreaRoutes } from './VehicleDataOverrideAreaRoutes'

const LazyVehicleDataOverrideComponent = lazy(
  () => import('./VehicleDataOverrideArea'),
)

const VehicleDataOverrideComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehicleDataOverrideComponent />
  </SuspenseLoadingWrapper>
)

export const VehicleDataOverrideArea = {
  id: VehicleDataOverrideAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_VEHICLE_DATA_OVERRIDE_CRUD,
  Icon: VehicleDataOverrideAreaNavigationIcon,
  NavigationComponent: VehicleDataOverrideAreaNavigation,
  route: {
    path: VehicleDataOverrideAreaRoutes.route,
    component: VehicleDataOverrideComponent,
  },
}
